export const activeCampaign = (() => {
	const activeCampaign_accept_marketing =
		document.querySelector('#activecampaign_for_woocommerce_accepts_marketing') || false
	if (activeCampaign_accept_marketing) activeCampaign_accept_marketing.className = 'form-check-input'
})()
